import * as React from 'react';

import { DropdownField } from '../../../components/dropdownField';

export enum EBathType {
  Bath = 'bath',
  Shower = 'shower',
}

export interface IBathTypeProps {
  bathTypes: EBathType[];
  onChange(value: EBathType[]): void;
}

export class BathType extends React.Component<IBathTypeProps> {
  public render() {
    return (
      <DropdownField
        multiple
        placeholder="Неважно"
        value={this.props.bathTypes.concat()}
        onValueChange={this.props.onChange}
        values={[
          { value: EBathType.Bath, label: 'Ванна' },
          { value: EBathType.Shower, label: 'Душевая кабина' },
        ]}
      />
    );
  }
}
